module.exports = __webpack_public_path__ + "img/1.d180163b.png";